<template>
  <div class="view" :style="{ paddingTop: barh(10) }">
    <div class="content">
      <my-top
        :title="titleMap[active]"
        :lefttext="active === 'todo' ? '': '返回'"
        :arrow="active === 'todo' ? false: true"
        v-bind="active === 'todo' ? { righttext: '已办事项' } : {}"
        @rightclick="handleSwitch('done')"
        @leftclick="handleBack"
        class="customStyle"
      ></my-top>
      <div class="screenbox" :style="{ top: navbarheight }">
        <tabs v-model="listType" class="sarchtabs" @change="clicktabs">
          <tab
            :badge="
              active === 'todo'
                ? item.id === '1'
                  ? todoCount
                  : todoCountBussiness
                : ''
            "
            v-for="item in approvallist"
            :title="item.name"
            :name="item.id"
            :key="item.id"
          >
          </tab>
        </tabs>
      </div>
      <mattersList :active="active" :listType="listType"></mattersList>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant'
import mattersList from './list.vue'

export default {
  name: 'matters',
  components: {
    mattersList,
    Tabs,
    Tab,
  },
  data() {
    return {
      titleMap: {
        todo: '待办事项',
        done: '已办事项',
      },
    }
  },
  computed: {
    // tabs列表
    approvallist() {
      let name = { todo: '待', done: '已' }[this.active]
      return [
        { name: `审批${name}办`, id: '1' },
        { name: `业务${name}办`, id: '2' },
      ]
    },
    active() {
      return this.$route.query.active || 'todo'
    },
    listType() {
      return this.$route.query.listType || '1'
    },
    todoCount() {
      let count = Number(this.$store.getters['messageInfo/GET_TODOCOUNT'])
      if (isNaN(count) || count == 0) {
        return null
      }
      return count > 99 ? '99+' : count
    },
    todoCountBussiness() {
      let count = Number(
        this.$store.getters['messageInfo/GET_TODOCOUNTBUSSINESS']
      )
      if (isNaN(count) || count == 0) {
        return null
      }
      return count > 99 ? '99+' : count
    },
  },
  methods: {
    /**
     * @description: 返回
     */
    handleBack() {
        this.handleSwitch('todo')
    },
    handleSwitch(name, title) {
      this.$router.replace({
        path: '/application/matters',
        query: {
          key: 2,
          active: name,
        },
      })
    },
    clicktabs(name) {
      this.$router.replace({
        path: '/application/matters',
        query: {
          key: 2,
          active: this.active,
          listType: name,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .customStyle {
    ::v-deep .van-nav-bar__content {
      justify-content: space-around;
    }
    ::v-deep .van-nav-bar__right {
      position: relative;
      padding: 0 0.7rem 0 0;
    }
    ::v-deep .van-nav-bar__title {
      margin: 0;
      padding-right: 1.6rem;
    }
  }
.view {
  .content {
    padding-bottom: 50px;
    ::v-deep .navbar {
      .van-nav-bar__right .van-nav-bar__text {
        color: #02a7f0;
      }
    }
    .screenbox {
      width: 100%;
      position: fixed;
      left: 0;
      z-index: 2;
      .sarch {
        ::v-deep .van-search {
          .van-search__content {
            border-radius: 20px;
          }
        }
      }
      .sarchtabs {
        ::v-deep .van-tabs__line {
          background-color: #018fe0;
          bottom: 18px;
        }
      }
    }
  }
}
</style>
